/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getInsuranceBookingDetails } from '../../api/profileApi';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import {
  formatDate,
  getNewDate,
  hideHeaderFooter,
  isEmpty,
  showHeaderFooter,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';

const formatCertificateDate = (val) => {
  if (!val) return '';
  try {
    if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val.trim())) {
      return val.trim();
    }
    const str = typeof val === 'string' ? val.split(' ')[0] : val;
    const d = getNewDate(str);
    const formatted = formatDate(d, 'YYYY-MM-DD');
    return (
      formatted || (typeof val === 'string' ? val.split(' ')[0] : String(val))
    );
  } catch {
    return typeof val === 'string' ? val.split(' ')[0] : String(val);
  }
};

function TuneProtectCertificate() {
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [hasTicket, setHasTicket] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const [bookingDetails, setBookingDetails] = useState({});
  const [paxList, setPaxList] = useState([]);

  const getInsuranceDetails = async () => {
    setLoading(true);
    try {
      const response = await getInsuranceBookingDetails(transactionId);
      if (response?.Root?.Status === 'OK') {
        const data =
          response.Root?.Result?.TravelInsuranceInvoice ||
          response.Root?.Result ||
          {};

        let rawPax = [];
        if (
          !isEmpty(data.TravelInsurancePassengers) &&
          !isEmpty(data.TravelInsurancePassengers.TravelInsurancePassenger)
        ) {
          const p = data.TravelInsurancePassengers.TravelInsurancePassenger;
          rawPax = Array.isArray(p) ? p : [p];
        } else if (data.PassengerDetails) {
          try {
            const parsed =
              typeof data.PassengerDetails === 'string'
                ? JSON.parse(data.PassengerDetails)
                : data.PassengerDetails;
            if (Array.isArray(parsed?.passengerDetails)) {
              rawPax = parsed.passengerDetails;
            } else if (Array.isArray(parsed)) {
              rawPax = parsed;
            } else if (parsed?.passengerDetails) {
              rawPax = [parsed.passengerDetails];
            } else if (parsed && typeof parsed === 'object') {
              rawPax = [parsed];
            }
          } catch (e) {
            rawPax = [];
          }
        } else if (data.primarypax) {
          rawPax = Array.isArray(data.primarypax)
            ? data.primarypax
            : [data.primarypax];
        }

        if (rawPax.length === 0 && data.InsuranceDetails) {
          try {
            const insDetails =
              typeof data.InsuranceDetails === 'string'
                ? JSON.parse(data.InsuranceDetails)
                : data.InsuranceDetails;
            const pInfo =
              insDetails?.Response?.Itinerary?.PaxInfo ||
              insDetails?.PaxInfo ||
              insDetails?.passengerDetails;
            if (pInfo) {
              rawPax = Array.isArray(pInfo) ? pInfo : [pInfo];
            }
          } catch (e) {
            // ignore
          }
        }

        setPaxList(rawPax);
        setBookingDetails(data);
        setHasTicket(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Insurance Voucher',
          description:
            response?.Root?.Message || 'Failed to load booking details',
        });
        setHasTicket(false);
      }
    } catch (err) {
      setAlert({
        variant: 'error',
        title: 'Insurance Voucher',
        description: 'Failed to load insurance certificate',
      });
      setHasTicket(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (transactionId) {
      getInsuranceDetails();
    }
  }, [transactionId]);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const firstPax = paxList && paxList.length > 0 ? paxList[0] : null;

  // Policy No - checks passenger record first, then invoice details, fallback to Txid
  const policyNo =
    (firstPax?.PolicyNumber &&
      firstPax.PolicyNumber !== '-' &&
      firstPax.PolicyNumber) ||
    (firstPax?.policynumber &&
      firstPax.policynumber !== '-' &&
      firstPax.policynumber) ||
    (firstPax?.policyNumber &&
      firstPax.policyNumber !== '-' &&
      firstPax.policyNumber) ||
    (bookingDetails.PolicyNumber &&
      bookingDetails.PolicyNumber !== '-' &&
      bookingDetails.PolicyNumber) ||
    (bookingDetails.PolicyNo &&
      bookingDetails.PolicyNo !== '-' &&
      bookingDetails.PolicyNo) ||
    (bookingDetails.policynumber &&
      bookingDetails.policynumber !== '-' &&
      bookingDetails.policynumber) ||
    (bookingDetails.InvoiceNumber &&
      bookingDetails.InvoiceNumber !== '-' &&
      bookingDetails.InvoiceNumber) ||
    bookingDetails.Txid ||
    bookingDetails.txid ||
    transactionId ||
    '-';

  // Issue date from TxDate / IssueDate / Invoicedate
  let issueDate = '-';
  if (bookingDetails.TxDate) {
    issueDate = formatCertificateDate(bookingDetails.TxDate.split(' ')[0]);
  } else if (bookingDetails.IssueDate) {
    issueDate = formatCertificateDate(bookingDetails.IssueDate);
  } else if (bookingDetails.Invoicedate) {
    issueDate = formatCertificateDate(bookingDetails.Invoicedate);
  } else if (bookingDetails.invoicedate) {
    issueDate = formatCertificateDate(bookingDetails.invoicedate);
  }

  // Plan Type from InsuranceName
  const planType =
    bookingDetails.InsuranceName ||
    bookingDetails.planname ||
    bookingDetails.PlanName ||
    bookingDetails.ProductDescription ||
    '-';

  // Departure and Return dates from startdate / enddate / departuredate / onwarddate
  const rawStartDate =
    bookingDetails.startdate ||
    bookingDetails.StartDate ||
    bookingDetails.departuredate ||
    bookingDetails.DepartureDate ||
    bookingDetails.onwarddate ||
    bookingDetails.OnwardDate ||
    firstPax?.StartDate ||
    firstPax?.startdate ||
    firstPax?.DepartureDate ||
    firstPax?.departuredate ||
    firstPax?.onwarddate ||
    firstPax?.traveldate ||
    firstPax?.travelStartDate;

  const rawEndDate =
    bookingDetails.enddate ||
    bookingDetails.EndDate ||
    bookingDetails.arrivaldate ||
    bookingDetails.ArrivalDate ||
    bookingDetails.returndate ||
    bookingDetails.ReturnDate ||
    firstPax?.EndDate ||
    firstPax?.enddate ||
    firstPax?.ArrivalDate ||
    firstPax?.arrivaldate ||
    firstPax?.returndate ||
    firstPax?.ReturnDate ||
    firstPax?.travelEndDate;

  const departureDate = rawStartDate
    ? formatCertificateDate(rawStartDate)
    : '-';

  const returnDate = rawEndDate ? formatCertificateDate(rawEndDate) : '-';

  // Calculate validity days
  let validityText = '-';
  try {
    if (
      departureDate &&
      departureDate !== '-' &&
      returnDate &&
      returnDate !== '-'
    ) {
      const d1 = new Date(departureDate);
      const d2 = new Date(returnDate);
      if (!Number.isNaN(d1.getTime()) && !Number.isNaN(d2.getTime())) {
        const diff = Math.ceil(Math.abs(d2 - d1) / (1000 * 60 * 60 * 24)) + 1;
        validityText = `${diff > 0 ? diff : 1} Day(s) (Return)`;
      }
    }
  } catch (e) {
    validityText = '-';
  }

  const passengersList =
    paxList.length > 0
      ? paxList.map((item, idx) => {
          const name =
            item.PaxName ||
            item.paxname ||
            item.paxName ||
            item.LeadPassengerName ||
            `${item.FirstName || item.firstname || ''} ${
              item.LastName || item.lastname || ''
            }`.trim() ||
            '-';

          let gender = item.Gender || item.gender || item.sex || item.Sex || '';
          if (!gender && (item.Title || item.title)) {
            const title = (item.Title || item.title)
              .toLowerCase()
              .replace('.', '')
              .trim();
            if (title === 'mr' || title === 'master') gender = 'MALE';
            else if (title === 'mrs' || title === 'ms' || title === 'miss')
              gender = 'FEMALE';
          }
          if (!gender) gender = '-';

          const dob =
            item.DOB || item.dob || item.DateOfBirth || item.dateOfBirth
              ? formatCertificateDate(
                  item.DOB || item.dob || item.DateOfBirth || item.dateOfBirth,
                )
              : '-';

          const nationality =
            item.Nationality ||
            item.nationality ||
            item.Country ||
            item.country ||
            item.CountryName ||
            item.countryName ||
            '-';

          const passport =
            item.Passport ||
            item.passport ||
            item.passportnumber ||
            item.PassportNumber ||
            item.passportNumber ||
            item.PassportNo ||
            item.passportNo ||
            '-';

          const rawUrl =
            item.PolicyURL ||
            item.policyURL ||
            item.policyUrl ||
            bookingDetails.PolicyURL ||
            bookingDetails.policyURL ||
            bookingDetails.document ||
            bookingDetails.Document ||
            '';
          let policyPdfUrl = '';
          if (rawUrl && typeof rawUrl === 'string') {
            try {
              if (rawUrl.startsWith('http')) {
                policyPdfUrl = rawUrl;
              } else {
                const decoded = atob(rawUrl);
                if (decoded.startsWith('http')) {
                  policyPdfUrl = decoded;
                }
              }
            } catch (e) {
              // ignore
            }
          }

          return {
            no: idx + 1,
            name,
            gender: gender !== '-' ? gender.toUpperCase() : '-',
            dob,
            nationality: nationality !== '-' ? nationality : '-',
            passport,
            policyPdfUrl,
          };
        })
      : [];

  let firstPassportNo = '-';
  if (passengersList[0]?.passport && passengersList[0].passport !== '-') {
    firstPassportNo = passengersList[0].passport;
  } else if (bookingDetails.Passport && bookingDetails.Passport !== '-') {
    firstPassportNo = bookingDetails.Passport;
  } else if (bookingDetails.passport && bookingDetails.passport !== '-') {
    firstPassportNo = bookingDetails.passport;
  } else if (
    bookingDetails.passportnumber &&
    bookingDetails.passportnumber !== '-'
  ) {
    firstPassportNo = bookingDetails.passportnumber;
  } else if (
    bookingDetails.PassportNumber &&
    bookingDetails.PassportNumber !== '-'
  ) {
    firstPassportNo = bookingDetails.PassportNumber;
  } else if (firstPax?.passportnumber && firstPax.passportnumber !== '-') {
    firstPassportNo = firstPax.passportnumber;
  }

  const areaDestination =
    bookingDetails.Destination ||
    bookingDetails.destination ||
    bookingDetails.origin ||
    bookingDetails.Origin ||
    firstPax?.Destination ||
    firstPax?.destination ||
    firstPax?.Country ||
    firstPax?.country ||
    firstPax?.city ||
    '';

  const hasAreaInName =
    areaDestination &&
    typeof areaDestination === 'string' &&
    areaDestination.toLowerCase().includes('area');

  const bookingStatus =
    bookingDetails.BookingStatus ||
    bookingDetails.bookingstatus ||
    bookingDetails.ProcessStatus ||
    bookingDetails.processstatus ||
    '-';

  const isStatusConfirmed =
    typeof bookingStatus === 'string' &&
    (bookingStatus.toLowerCase() === 'confirm' ||
      bookingStatus.toLowerCase() === 'confirmed');

  const paymentStatus =
    bookingDetails.PaymentStatus ||
    bookingDetails.paymentstatus ||
    bookingDetails.paymentStatus ||
    '-';

  const downloadPolicyUrl = passengersList[0]?.policyPdfUrl || '';

  return (
    <section
      className="tune-certificate-page flight-ticket-invoice-page"
      style={{
        backgroundColor: '#fff',
        minHeight: '100vh',
        padding: '20px 10px',
        color: '#333',
        fontFamily: 'Arial, Helvetica, sans-serif',
      }}
    >
      <AppLoading isLoading={isLoading} />

      {/* Floating print & home buttons */}
      <section className="print-links d-flex flex-column hide-in-print">
        <a
          onClick={() => window.print()}
          title="Print Certificate"
          style={{ cursor: 'pointer' }}
        >
          <img src="/images/others/print_sidebutton.png" alt="Print" />
        </a>
        <a href={NAVIGATION_ROUTES.LANDING} title="Home">
          <img src="/images/others/home_sidebutton.png" alt="Home" />
        </a>
      </section>

      {alert && (
        <div
          className="hide-in-print"
          style={{ maxWidth: '820px', margin: '0 auto 15px' }}
        >
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        </div>
      )}

      {hasTicket !== undefined && hasTicket && (
        <div
          className="tune-certificate-container"
          style={{
            width: '100%',
            maxWidth: '820px',
            margin: '0 auto',
            backgroundColor: '#fff',
            padding: '20px 25px',
            boxSizing: 'border-box',
          }}
        >
          {/* Certificate Title */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div style={{ flex: 1 }} />
            <h1
              style={{
                color: '#c4161c',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '32px',
                margin: '10px 0 25px 0',
                letterSpacing: '0.2px',
                flex: 2,
              }}
            >
              Certificate of Insurance
            </h1>
            <div
              style={{ flex: 1, textAlign: 'right' }}
              className="hide-in-print"
            >
              {downloadPolicyUrl && (
                <a
                  href={downloadPolicyUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-sm btn-outline-danger fw-600"
                  style={{ fontSize: '12px' }}
                >
                  Download PDF
                </a>
              )}
            </div>
          </div>

          {/* Tune Protect Main Details Table */}
          <div style={{ width: '100%', border: '1px solid #c4161c' }}>
            {/* Table Header Bar */}
            <div
              style={{
                backgroundColor: '#b81d24',
                color: '#ffffff',
                fontWeight: 'bold',
                fontSize: '14px',
                padding: '8px 12px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>Tune Protect Travel Assurance</span>
              {bookingStatus && bookingStatus !== '-' && (
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    backgroundColor: '#ffffff',
                    color: isStatusConfirmed ? '#2e7d32' : '#c4161c',
                    padding: '2px 10px',
                    borderRadius: '3px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Status: {bookingStatus}
                </span>
              )}
            </div>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '13px',
                backgroundColor: '#fff',
              }}
            >
              <tbody>
                {/* Row 1: Policy No & Issue Date */}
                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td
                    style={{
                      width: '18%',
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    Policy No.
                  </td>
                  <td
                    style={{
                      width: '32%',
                      padding: '8px 12px',
                      color: '#333',
                      borderRight: '1px solid #f0f0f0',
                      fontWeight: '600',
                    }}
                  >
                    {policyNo}
                  </td>
                  <td
                    style={{
                      width: '18%',
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    Issue Date
                  </td>
                  <td
                    style={{ width: '32%', padding: '8px 12px', color: '#333' }}
                  >
                    {issueDate}
                  </td>
                </tr>

                {/* Row 2: Area of Travel & Plan Type */}
                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                      verticalAlign: 'top',
                    }}
                  >
                    of Travel
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#333',
                      borderRight: '1px solid #f0f0f0',
                      verticalAlign: 'top',
                    }}
                  >
                    <div>
                      {areaDestination ? (
                        <>
                          <span className="text-capitalize">
                            {areaDestination}
                          </span>
                          {!hasAreaInName && (
                            <>
                              {' '}
                              <span
                                style={{ color: '#c4161c', fontWeight: 'bold' }}
                              >
                                Area
                              </span>
                            </>
                          )}
                        </>
                      ) : (
                        '-'
                      )}
                    </div>
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                      verticalAlign: 'top',
                    }}
                  >
                    Plan Type
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#333',
                      verticalAlign: 'top',
                    }}
                  >
                    {planType}
                  </td>
                </tr>

                {/* Row 3: Departure Date & Return Date */}
                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    Departure Date
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#333',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    {departureDate}
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    Return Date
                  </td>
                  <td style={{ padding: '8px 12px', color: '#333' }}>
                    {returnDate}
                  </td>
                </tr>

                {/* Row 4: Validity & Passport No */}
                <tr
                  style={{
                    borderBottom:
                      bookingStatus !== '-' ? '1px solid #f0f0f0' : 'none',
                  }}
                >
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    Validity
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#333',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    {validityText}
                  </td>
                  <td
                    style={{
                      padding: '8px 12px',
                      color: '#c4161c',
                      fontWeight: 'bold',
                      borderRight: '1px solid #f0f0f0',
                    }}
                  >
                    Passport No.
                  </td>
                  <td style={{ padding: '8px 12px', color: '#333' }}>
                    {firstPassportNo}
                  </td>
                </tr>

                {/* Row 5: Booking Status & Payment Status */}
                {bookingStatus !== '-' && (
                  <tr>
                    <td
                      style={{
                        padding: '8px 12px',
                        color: '#c4161c',
                        fontWeight: 'bold',
                        borderRight: '1px solid #f0f0f0',
                      }}
                    >
                      Booking Status
                    </td>
                    <td
                      style={{
                        padding: '8px 12px',
                        color: isStatusConfirmed ? '#2e7d32' : '#c4161c',
                        borderRight: '1px solid #f0f0f0',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                      }}
                    >
                      {bookingStatus}
                    </td>
                    <td
                      style={{
                        padding: '8px 12px',
                        color: '#c4161c',
                        fontWeight: 'bold',
                        borderRight: '1px solid #f0f0f0',
                      }}
                    >
                      Payment Status
                    </td>
                    <td
                      style={{
                        padding: '8px 12px',
                        color:
                          typeof paymentStatus === 'string' &&
                          paymentStatus.toLowerCase() === 'paid'
                            ? '#2e7d32'
                            : '#333',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                      }}
                    >
                      {paymentStatus}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Insured Passengers Table */}
          <div style={{ width: '100%', marginTop: '1px' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '13px',
                backgroundColor: '#fff',
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: '#b81d24',
                    color: '#ffffff',
                    fontWeight: 'bold',
                  }}
                >
                  <th
                    style={{
                      padding: '8px 10px',
                      width: '8%',
                      textAlign: 'left',
                    }}
                  >
                    No.
                  </th>
                  <th
                    style={{
                      padding: '8px 10px',
                      width: '40%',
                      textAlign: 'left',
                    }}
                  >
                    Insured Name
                  </th>
                  <th
                    style={{
                      padding: '8px 10px',
                      width: '18%',
                      textAlign: 'center',
                    }}
                  >
                    Gender
                  </th>
                  <th
                    style={{
                      padding: '8px 10px',
                      width: '18%',
                      textAlign: 'center',
                    }}
                  >
                    DOB
                  </th>
                  <th
                    style={{
                      padding: '8px 10px',
                      width: '16%',
                      textAlign: 'right',
                    }}
                  >
                    Nationality
                  </th>
                </tr>
              </thead>
              <tbody>
                {passengersList.length > 0 ? (
                  passengersList.map((pax) => (
                    <tr
                      key={pax.no}
                      style={{
                        borderBottom: '1px solid #e0e0e0',
                        color: '#333',
                      }}
                    >
                      <td style={{ padding: '8px 10px', textAlign: 'left' }}>
                        {pax.no}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'left' }}>
                        {pax.name}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'center' }}>
                        {pax.gender}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'center' }}>
                        {pax.dob}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right' }}>
                        {pax.nationality}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      style={{
                        padding: '12px',
                        textAlign: 'center',
                        color: '#777',
                      }}
                    >
                      No passenger records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Emergency Assistance Section */}
          <div
            style={{
              border: '1px solid #999',
              marginTop: '22px',
              padding: '12px 14px',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#222',
                marginBottom: '10px',
              }}
            >
              Emergency Assistance
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              {/* Middle East */}
              <div style={{ flex: '1 1 22%', minWidth: '160px' }}>
                <div
                  style={{
                    color: '#c4161c',
                    fontWeight: 'bold',
                    fontSize: '13px',
                  }}
                >
                  Middle East
                </div>
                <div
                  style={{ color: '#333', fontSize: '12px', marginTop: '2px' }}
                >
                  +971 45711000
                </div>
                <div
                  style={{
                    color: '#444',
                    fontStyle: 'italic',
                    fontSize: '11px',
                    marginTop: '2px',
                  }}
                >
                  (English &amp; Arabic)
                </div>
              </div>

              {/* US & Canada */}
              <div style={{ flex: '1 1 22%', minWidth: '160px' }}>
                <div
                  style={{
                    color: '#c4161c',
                    fontWeight: 'bold',
                    fontSize: '13px',
                  }}
                >
                  US &amp; Canada
                </div>
                <div
                  style={{ color: '#333', fontSize: '12px', marginTop: '2px' }}
                >
                  +178 6472 7700
                </div>
                <div
                  style={{
                    color: '#444',
                    fontStyle: 'italic',
                    fontSize: '11px',
                    marginTop: '2px',
                  }}
                >
                  (English, French &amp; Arabic)
                </div>
              </div>

              {/* Europe/North Africa */}
              <div style={{ flex: '1 1 22%', minWidth: '160px' }}>
                <div
                  style={{
                    color: '#c4161c',
                    fontWeight: 'bold',
                    fontSize: '13px',
                  }}
                >
                  Europe/North Africa
                </div>
                <div
                  style={{ color: '#333', fontSize: '12px', marginTop: '2px' }}
                >
                  +44 178 631 0605
                </div>
                <div
                  style={{
                    color: '#444',
                    fontStyle: 'italic',
                    fontSize: '11px',
                    marginTop: '2px',
                  }}
                >
                  (English, French &amp; Arabic)
                </div>
              </div>

              {/* Indian Subcontinent */}
              <div style={{ flex: '1 1 22%', minWidth: '160px' }}>
                <div
                  style={{
                    color: '#c4161c',
                    fontWeight: 'bold',
                    fontSize: '13px',
                  }}
                >
                  Indian Subcontinent
                </div>
                <div
                  style={{ color: '#333', fontSize: '12px', marginTop: '2px' }}
                >
                  +91 124 4688 434
                </div>
                <div
                  style={{
                    color: '#444',
                    fontStyle: 'italic',
                    fontSize: '11px',
                    marginTop: '2px',
                  }}
                >
                  (English &amp; Arabic)
                </div>
              </div>
            </div>
          </div>

          {/* Terms and Conditions Apply */}
          <div style={{ marginTop: '12px' }}>
            <div
              style={{
                fontStyle: 'italic',
                fontWeight: 'bold',
                fontSize: '11.5px',
                color: '#222',
                marginBottom: '5px',
              }}
            >
              Terms and conditions apply
            </div>
            <ol
              style={{
                paddingLeft: '18px',
                margin: 0,
                fontSize: '10.5px',
                color: '#444',
                lineHeight: '1.45',
              }}
            >
              <li>
                Tune Protect Travel Assurance shall not be subject to
                assignment, change, upgrade and/or refund.
              </li>
              <li>
                For Covid-19 related claims, up to 20% sublimit for accidental
                and medical reimbursement limit depending on the plan selected.
              </li>
              <li>
                Insured Person is required to pay a policy Excess of USD 100.00
                and only applicable for Accidental &amp; Sickness Medical
                Reimbursement Claim.
              </li>
              <li>
                In the event of hospitalization, the Insured Person or treating
                hospital is required to contact the assigned Emergency
                Assistance within twenty-four (24) hours of admission and the
                Insured Person or treating hospital must receive an
                acknowledgement on the coverage. Failure to do so will result in
                claim being denied.
              </li>
              <li>
                Pre-existing medical conditions are excluded as stated in the
                General Exclusions Section of the Policy Wording.
              </li>
              <li>
                The Insured/ Claimant will need to submit the claim within
                thirty (30) days from the incident and has maximum of ninety
                (90) days to submit all supporting documents of the incident.
              </li>
              <li>
                Annual Cover - Covers multiple trips in which each trip does not
                exceed 92 days.
              </li>
              <li>Schengen Visa Compliant.</li>
              <li>
                I/Holder of the Policy hereby agree to the Terms &amp;
                Conditions of this Certificate of Insurance and the benefits/
                coverages.
              </li>
              <li>
                Medical coverage will start upon arrival at the destination.
              </li>
            </ol>
          </div>
        </div>
      )}
    </section>
  );
}

export default TuneProtectCertificate;
